export default __webpack_public_path__ + "static/media/slider_inicio_1.996aa19f.jpg";